module.exports = __webpack_public_path__ + "static/media/Illus-Pickup_1.d6dab358.png";